import { useMemo } from 'react';
import { useParams } from 'react-router';

import { SupportBreadcrumbsRoute, RouteGeneratorMap, RouteTitleMap, RouteParamsMap } from './types';
import { createClusterRoutes, createLeaderboardRoutes, createLookupRoutes, createTeamLookupRoutes } from './helpers';

const routeGenerators: RouteGeneratorMap = {
  [SupportBreadcrumbsRoute.Lookup]: createLookupRoutes,
  [SupportBreadcrumbsRoute.Clusterization]: createClusterRoutes,
  [SupportBreadcrumbsRoute.Leaderboards]: createLeaderboardRoutes,
  [SupportBreadcrumbsRoute.TeamLookup]: createTeamLookupRoutes,
};

export const useGetRoutes = <T extends SupportBreadcrumbsRoute>({
  module,
  title,
}: {
  module: T;
  title?: RouteTitleMap[T];
}) => {
  const params = useParams<RouteParamsMap[T]>();

  const routes = useMemo(() => {
    const createRoutes = routeGenerators[module];
    if (createRoutes === undefined) {
      console.warn(`No route createRoutes found for module: ${module}`);
      return [];
    }
    return createRoutes(params, title) ?? [];
  }, [module, params, title]);

  return routes;
};
